import { render, staticRenderFns } from "./RootTipiOspiteView.vue?vue&type=template&id=ed7aa00a&"
import script from "./RootTipiOspiteView.vue?vue&type=script&lang=ts&"
export * from "./RootTipiOspiteView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports